import type { RenderElementProps } from 'slate-react';

import React from 'react';

const Figure = ({ children, attributes }: RenderElementProps) => {
  return <figure {...attributes}>{children}</figure>;
};

export default Figure;
